import { forwardRef, useMemo } from 'react'

import type { InputNumberRef } from '@rc-component/input-number'
import { InputNumber } from 'antd'
import type { InputNumberProps } from 'antd'
import cn from 'classnames'
import { nanoid } from 'nanoid'

import styles from '@web/shared/components/app-input-number/ui/app-input-number.module.css'
import { locales } from '@web/shared/constants/locales.constant'

type TProps = InputNumberProps & {
  width?: number
  label?: string
  readOnly?: boolean
}

export const AppInputNumber = forwardRef<InputNumberRef, TProps>(
  (
    { width, label, readOnly, ...props },
    ref
  ) => {
    const inputId = useMemo(() => nanoid(), [])

    const input = (
      <InputNumber
        {...props}
        id={inputId}
        ref={ref}
        decimalSeparator={locales.ru.decimalSeparator}
        style={{ width }}
        controls={!readOnly}
        className={cn({ [styles.readOnly]: readOnly })}
        tabIndex={readOnly ? -1 : 0}
        disabled={readOnly ?? props.disabled}
        placeholder={readOnly ? undefined : props.placeholder}
      />
    )

    if (!label) return input

    return (
      <div className={styles.container}>
        <span className={styles.label}>{label}</span>
        {input}
      </div>
    )
  }
)
